<template>
  <div
    v-if="open"
    class="impersonation-confirm-overlay"
    @click.self="onCancel">
    <div class="impersonation-confirm-modal">
      <div class="confirm-icon"><i class="ik ik-log-out" /></div>
      <h3>{{ title }}</h3>
      <p><slot /></p>
      <div class="confirm-actions">
        <button
          class="confirm-cancel"
          :disabled="loading"
          @click="onCancel">{{ cancelLabel }}</button>
        <button
          class="confirm-end"
          :disabled="loading"
          @click="onConfirm">{{ loading ? loadingLabel : confirmLabel }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImpersonationConfirmModal',
  props: {
    open: { type: Boolean, required: true },
    title: { type: String, required: true },
    confirmLabel: { type: String, required: true },
    cancelLabel: { type: String, required: true },
    loadingLabel: { type: String, required: true },
    loading: { type: Boolean, default: false }
  },
  methods: {
    onCancel () {
      if (this.loading === true) return
      this.$emit('cancel')
    },
    onConfirm () {
      if (this.loading === true) return
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.impersonation-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(20, 12, 36, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1040;
}

.impersonation-confirm-modal {
  background: #fff;
  border-radius: 14px;
  max-width: 440px;
  width: calc(100% - 32px);
  padding: 28px;
  box-shadow: 0 24px 60px rgba(76, 29, 149, 0.35);
  text-align: center;
}

.confirm-icon {
  width: 52px;
  height: 52px;
  border-radius: 13px;
  background: rgba(124, 58, 237, 0.12);
  color: #7c3aed;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 14px;
}

.impersonation-confirm-modal h3 {
  margin: 0 0 8px;
  font-size: 19px;
  font-weight: 700;
  color: #1f2a37;
}

.impersonation-confirm-modal p {
  margin: 0 0 22px;
  font-size: 13.5px;
  line-height: 1.5;
  color: #475467;
}

.confirm-actions {
  display: flex;
  gap: 10px;
}

.confirm-cancel,
.confirm-end {
  flex: 1;
  height: 42px;
  border-radius: 9px;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
}

.confirm-cancel {
  background: #fff;
  color: #475467;
  border: 1px solid #e6e8ed;
}

.confirm-end {
  background: #7c3aed;
  color: #fff;
  border: 0;
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.28);
}
</style>



// WEBPACK FOOTER //
// src/components/Support/ImpersonationConfirmModal.vue